import Vue from 'vue';
import store from '../../store';
import batchLogTransformer from '../../transformers/batchLog';

const success = ({ data }, resolve) => {
  const batchLogs = batchLogTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllBatchLogs', batchLogs);
  resolve(batchLogs);
};

const failed = () => {};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/production/batch_log')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batchLog/all.js